import { useDispatchApp, useSelectorApp } from "../lib/redux";
import {
  setNotificationsPanelIsExpanded,
  setNotificationsPanelIsClosed,
} from "../actions/ui";
import { useNotifications } from "./useNotifications";

export const useNotificationsToggle = () => {
  const dispatch = useDispatchApp();
  const notificationsPanelIsExpanded = useSelectorApp(
    (state) => state.alerts?.notificationsPanelIsExpanded || false
  );
  const { hasActiveProcessing } = useNotifications();

  const onToggle = () => {
    const newExpandedState = !notificationsPanelIsExpanded;
    dispatch(setNotificationsPanelIsExpanded(newExpandedState));

    if (newExpandedState) {
      dispatch(setNotificationsPanelIsClosed(false));
    } else {
      dispatch(setNotificationsPanelIsClosed(true));
    }
  };

  return {
    onToggle,
    hasActiveProcessing,
  };
};
